"use client";

import Image from "next/image";
import { useTheme } from "next-themes";

export function LogoLoader({ message }: { message?: string }) {
	const { theme } = useTheme();

	return (
		<div className="flex h-screen w-screen items-center justify-center bg-background">
			<div className="flex flex-col items-center gap-6">
				<div className="relative">
					<Image
						src={
							theme === "dark"
								? "/brand-mark-dark.png"
								: "/brand-mark-light.png"
						}
						alt="RouterBench Logo"
						width={120}
						height={120}
						priority
						className="h-auto w-auto animate-pulse"
					/>
				</div>
				{message && (
					<p className="text-sm text-muted-foreground animate-pulse">
						{message}
					</p>
				)}
			</div>
		</div>
	);
}

export function LogoLoaderSmall({ message }: { message?: string }) {
	const { theme } = useTheme();

	return (
		<div className="flex items-center justify-center p-8">
			<div className="flex flex-col items-center gap-4">
				<div className="relative">
					<Image
						src={
							theme === "dark"
								? "/brand-mark-dark.png"
								: "/brand-mark-light.png"
						}
						alt="RouterBench Logo"
						width={80}
						height={80}
						priority
						className="h-auto w-auto animate-pulse"
					/>
				</div>
				{message && (
					<p className="text-sm text-muted-foreground animate-pulse">
						{message}
					</p>
				)}
			</div>
		</div>
	);
}
